import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import { $get, $post } from './utils/request'
import VueClipboard from 'vue-clipboard2'


Vue.config.devtools = false;
Vue.config.productionTip = false;

Vue.prototype.$get = $get
Vue.prototype.$post = $post

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueClipboard)

import axios from 'axios'

axios.get('/config.json').then((res) => {
  // 基础地址
  Vue.prototype.BASE_URL = res.data.BASE_URL
  Vue.prototype.config = res.data
  new Vue({
    render: h => h(App),
  }).$mount('#app')
  // if (res.data.baidu_statistics) {
  //   router.beforeEach((to, from, next) => {
  //     setTimeout(() => {
  //       eval(res.data.baidu_statistics)
  //     }, 50)
  //     next()
  //   })
  // }
})

